export const formatFaNumber = (value?: number | null) => {
  if (value == null) return '-';

  return new Intl.NumberFormat('fa-IR', {
    maximumFractionDigits: 4,
    minimumFractionDigits: 0,
  }).format(value);
};
